/*
 *
 * NotificationEngine reducer
 *
 */

import { fromJS } from 'immutable';
import {
  SHOW_NOTIFICATION,
  DISMISS_NOTIFICATION,
} from './constants';

const initialState = fromJS({
  active: [],
});

function notificationEngineReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return state.updateIn(['active'], (arr) => {
        const a = arr.toJS();
        a.push({
          id: action.id,
          timeout: action.timeout,
          notificationType: action.nType,
          message: action.message,
          onClickAction: action.onClickAction,
          onDismissAction: action.onDismissAction,
        });
        return fromJS(a);
      });
    case DISMISS_NOTIFICATION:
      return state.updateIn(['active'], (arr) => {
        const a = arr.toJS();
        return fromJS(a.filter((notif) => notif.id !== action.id));
      });
    default:
      return state;
  }
}

export default notificationEngineReducer;
